import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { getBreakpointsEnable } from 'lib'
import { DonorListCard } from '../../../Parts/DonorListCard'

const styles = theme => ({
  root: {
    maxWidth: 1200,
    margin: 'auto',
    width: 'calc(100% - 16px)'
  },
  title: {
    margin: theme.spacing.unit * 7,
    textAlign: 'center',
  },
})

class Home extends React.Component  {
  render() {
    const { classes, theme, width } = this.props
    var { sm } = getBreakpointsEnable(theme, width)
    var styles = {
      gridRoot: {
        marginTop:
          sm ? theme.spacing.unit * 13 : theme.spacing.unit * 11
      },
      welcomeBox: {
        marginLeft: 'auto',
        marginRight: 'auto',
      }
    }

    return (
      <React.Fragment>
        <MenuAppBar />
        <div className={classes.root}>
          <Grid container spacing={0} style={styles.gridRoot}>
            <Grid item sm={8} xs={12}>
            </Grid>
            <Grid item sm={4} xs={12}>
              <DonorListCard/>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(Home)



// WEBPACK FOOTER //
// ./src/Pages/Home/components/Home.js